export enum ToolCallStatusAction {
    Accepted = "Accepted",
    Dismissed = "Dismissed",
    Received = "Received",
    InProgress = "InProgress",
    Completed = "Completed",
}
